export default function (state, val) {
    for (let k in val) {
        if (typeof state[k] !== 'undefined') state[k] = val[k];
    }
}